import { Component, ElementRef } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Department, GSTInfo, Product, ProductInventory, ProductLedger, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { Warehouse } from '../../../../model/administration.model';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesService } from '../../../../services/sales.service';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { VendorLookupComponent } from '../../../Lookup/vendor-lookup/vendor-lookup.component';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import _ from 'lodash';
import { InventoryService } from '../../../../services/inventory.service';
import { ShipToCustomerLookupComponent } from '../../../Lookup/shiptocustomer-lookup/shiptocustomer-lookup.component';
import { CustomerService } from '../../../../services/customer.service';


@Component({
  selector: 'app-receive-purchaseorder',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './receive-purchaseorder.component.html',
  styleUrl: './receive-purchaseorder.component.scss'
})
export class ReceivePurchaseorderComponent {



  loader: boolean = false;
  selectedProduct: Product[] = [];
  purchaseOrderId: any;
  purchaseOrderLineItemId: any;
  submitted: any;
  warehouseDropdown: any[] = [];
  departmentDropdown: any[] = [];
  filtewarehouse: Warehouse[] = [];
  filterDepartments: Department[] = [];
  filterProductList: any[] = [];
  products: Product[] = [];
  manualEntryChecked: boolean = false;
  deleteProductIds: any[] = [];

  isEditMode: boolean = true;
  addProductData: any;
  allProductData: Product[] = [];
  GSTList: GSTInfo[] = [];
  hsncode: any;
  CGSTtotal: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  orderTotal: number = 0;
  POLineItemData: any;
  TaxTotal: number = 0;
  Taxable: number = 0;

  isIGST: boolean = false;
  vendorState: string | undefined;
  warehouseState: string | undefined;
  ShipTocustomerList: any[] = [];

  constructor(public dialogService: DialogService, public ref: DynamicDialogRef, private warehouseService: AdministratorService,
    private router: Router, private route: ActivatedRoute, private messageService: MessageService, private confirmationService: ConfirmationService,
    private salesService: SalesService, private customerService:CustomerService ,  private porderservice: PurchaseorderService, private el: ElementRef, private inventoryService: InventoryService) { }

  ngOnInit(): void {
    this.purchaseOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.purchaseOrderLineItemForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.getWarehouse(this.pageRequest);
    this.getDepartment(this.pageRequest);
    this.editPurchaseOrder();
    this.manualEntry();
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  purchaseOrderForm = new FormGroup({
    purchaseOrderNumber: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]*$/)]),
    warehouses: new FormControl('', Validators.required),
    warehouseId: new FormControl(),
    warehouseCode: new FormControl(),
    requestedDate: new FormControl('', Validators.required),
    poTotal: new FormControl(),
    SGSTtotal: new FormControl(),
    CGSTtotal: new FormControl(),
    IGSTTotal: new FormControl(),
    TaxTotal: new FormControl(),
    vendorId: new FormControl(),
    vendorCode: new FormControl('', Validators.required),
    add: new FormControl(),
    addressId: new FormControl(),
    ShipToCustomerId: new FormControl('', Validators.required),
    ShipToCustomerCode: new FormControl('', Validators.required),
    ShipToCustomer: new FormControl('', Validators.required),
    ShipToCustomerAddress: new FormControl(''),
    shipViaCode: new FormControl(),
    departments: new FormControl('', Validators.required),
    departmentId: new FormControl(),
    departmentCode: new FormControl(),
    termsCode: new FormControl(),
    specialInstruction: new FormControl(),
    purchaseOrderComment: new FormControl(),
    isActive: new FormControl(true),
    CreatedBy: new FormControl(),
    manualEntry: new FormControl(false)
  })

  purchaseOrderLineItemForm = new FormGroup({
    PurchaseOrderNumber: new FormControl(''),
    Quantity: new FormControl(''),
    LineItemNumber: new FormControl(''),
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productData: new FormControl(''),
    Cost: new FormControl(''),
    Uom: new FormControl(''),
    AdjustedQuantity: new FormControl(''),
    ExtendedCost: new FormControl(''),
    GSTRate: new FormControl(''),
    CGST: new FormControl(''),
    SGST: new FormControl(''),
    IGST: new FormControl(''),
    Weight: new FormControl(''),
    ImportDuty: new FormControl(''),
    PurchaseOrderComment: new FormControl(''),
    IsActive: new FormControl(''),
    IsSpecialOrder: new FormControl(''),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),

  })


  setShipTo(data: any) {
    if (data.value) {
      this.purchaseOrderForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
      this.purchaseOrderForm.controls.ShipToCustomer.setValue(data.value.customerName);
      this.purchaseOrderForm.controls.ShipToCustomerId.setValue(data.value.customerId);
      const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
      this.purchaseOrderForm.controls.ShipToCustomerAddress.setValue(address);
    }
  }
  

  autosearchShiptoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.ShipTocustomerList = data.filter((customer: any) => customer.isShipToCustomer === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  openShipToCustomerLookup() {
    const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
      header: 'Ship To Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.purchaseOrderForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
        this.purchaseOrderForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
        this.purchaseOrderForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
        const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
        this.purchaseOrderForm.controls.ShipToCustomerAddress.setValue(address);
      }
    });
  }


  createPO(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    this.porderservice.createPurchaseOrder(data).subscribe({
      next: (data: any) => {
        this.createPOrderLineItem(this.POLineItemData)
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Created Successfully.' })
        this.router.navigate(['/home/listPurchaseOrders']);
      },
      error: error => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Purchase Order.' });
      }
    });

  }

  // updatePO(data: any) {

  //   if (this.products.length < 1) {
  //     this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
  //     const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
  //     if (productCodeAutoCompleteElement) {
  //       productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     }
  //     return;
  //   }

  //   this.loader = true;
  //   if (this.deleteProductIds && this.deleteProductIds.length > 0) {
  //     this.porderservice.deletePurchaseOrderLineitem(this.deleteProductIds).subscribe({
  //       next: (data: any) => {
  //         if (data) {
  //         }
  //       },
  //       error: error => {
  //         console.log(error);
  //       }
  //     });
  //   }

  //   for (const product of this.products) {

  //     if (product.purchaseOrderLineItemId !== undefined && product.purchaseOrderLineItemId !== null) {
  //       this.loader = true;
  //       this.porderservice.updatePurchaseOrderLineitem(product).subscribe(
  //         (data: any) => {

  //         },
  //         (error: any) => {
  //           console.log(error);
  //           this.loader = false;
  //         }
  //       );
  //     } else {
  //       this.loader = true;
  //       this.porderservice.createPurchaseOrder(product).subscribe(
  //         (data: any) => {
  //           if (data) {
  //             this.loader = false;
  //           } else {
  //             this.loader = false;
  //           }
  //         },
  //         (error: any) => {
  //           console.log(error);
  //           this.loader = false;
  //         }
  //       );
  //     }
  //   }

  //   data.purchaseOrderId = this.purchaseOrderId
  //   if (data) {
  //     this.porderservice.updatePurchaseOrder(data).subscribe({
  //       next: data => {
  //         this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Updated Successfully.' });
  //         this.router.navigate(['/home/listPurchaseOrders']);
  //       },
  //       error: error => {
  //         console.error('Error updating PurchaseOrders:', error);
  //       }
  //     });
  //   }

  // }

  // savePOrder(data: any, isEditMode: boolean) {
  //   if (isEditMode) {
  //     this.updatePOrder(data);
  //   } else {
  //     this.createPOrder(data);
  //   }
  // }

  createPOrder(data: any) {
    this.porderservice.createPurchaseOrder(data).subscribe({
      next: (data: any) => {
        this.createPOrderLineItem(this.POLineItemData)
      },
      error: error => {
        console.log(error);
      }
    });
  }

  updatePOrder(data: any) {
    data.purchaseOrderId = this.purchaseOrderId
    if (data) {
      this.porderservice.updatePurchaseOrder(data).subscribe({
        next: responseData => {
          this.createPOrderLineItem(this.POLineItemData)
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Updated Successfully.' });
          this.router.navigate(['/home/listPurchaseOrders']);
        },
        error: error => {
          console.error('Error updating PurchaseOrders:', error);
        }
      });
    } else {
      this.createPOrder(data);
    }
  }



  createPOrderLineItem(data: any) {
    for (const product of data) {
      const productData = { ...product };
      this.porderservice.createPurchaseOrderLineItem(productData).subscribe({
        next: (data: any) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Created Successfully.' });
          this.router.navigate(['/home/listPurchaseOrders']);
        },
        error: error => {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Purchase Order.' });
          console.log(error);
        }
      })
    }
  }

  updatePOrderLineItem(data: any) {
    if (data) {
      this.porderservice.updatePurchaseOrderLineitem(data).subscribe({
        next: data => {
          // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Lineitem Updated Successfully.' });
        },
        error: error => {
          console.error('Error updating PurchaseOrders:', error);
        }
      });
    } else {
      this.createPOrderLineItem(data);
    }
  }

  deletePOLineitem() {
    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      message: 'Do you want to delete?',
      accept: () => {

        var selectedProductIds: any
        if (!this.isEditMode) {

          selectedProductIds = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !selectedProductIds.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();

        } else {
          this.deleteProductIds.push(
            ...this.selectedProduct
              .map(product => product.purchaseOrderLineItemId)
              .filter(id => {
                return id && id.toString().trim() !== '';
              })
          );

          selectedProductIds = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !selectedProductIds.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();
        }

      },
      reject: () => {
        // Do nothing if user rejects deletion
      }
    });
  }


  getWarehouse(query: gridPageRequest) {
    this.warehouseService.getAllWarehouse(query).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
      }
    });
  }

  filteWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let warehouses = (this.warehouseDropdown as any[])[i];
      if (warehouses.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(warehouses);
      }
    }
    this.filtewarehouse = filtered;
  }

  SelectedWarehouse(event: any) {
    if (event && event.value) {
      const selectedWarehouse = event.value;
      this.purchaseOrderForm.controls['warehouseCode'].setValue(selectedWarehouse.warehouseCode);
      this.purchaseOrderForm.controls['warehouseId'].setValue(selectedWarehouse.warehouseId);
      this.warehouseState = selectedWarehouse.address.state;
    }
  }

  getVendor() {
    this.ref = this.dialogService.open(VendorLookupComponent, {
      header: 'Vendor List',
      width: '60%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          vendorId: data.vendorId,
          vendorCode: data.vendorCode,
          addressId: data.addressId,
          add: `${data.address.addressLine1},${data.address.city} ${data.address.state}, ${data.address.country},${data.address.zip}`
        });
        this.vendorState = data.address.state;
      }
    });
  }

  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          termsCode: data.termsCode
        })
      }
    })
  }

  getDepartment(query: gridPageRequest) {
    this.porderservice.getDepartment(query).subscribe({
      next: (data: any) => {
        this.departmentDropdown = data.department;
      }
    });
  }

  filterDepartment(event: any) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < (this.departmentDropdown as any[]).length; i++) {
      let departments = (this.departmentDropdown as any[])[i];
      if (departments.departmentCode.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(departments);
      }
    }
    this.filterDepartments = filtered;
  }

  SelectedDepartment(event: any) {
    if (event && event.value) {
      const SelectedDepartment = event.value;
      this.purchaseOrderForm.controls['departmentCode'].setValue(SelectedDepartment.departmentCode);
      this.purchaseOrderForm.controls['departmentId'].setValue(SelectedDepartment.departmentId);
    }
  }

  manualEntry() {
    if (!this.isEditMode) {
      const manualEntryValue = this.purchaseOrderForm.controls.manualEntry.value;
      this.manualEntryChecked = manualEntryValue === true;

      if (this.manualEntryChecked) {
        this.purchaseOrderForm.controls.purchaseOrderNumber.setValue('');
      } else {
        // this.getManuyalEntry();
      }
    }
  }

  // getManuyalEntry() {
  //   this.porderservice.getManuyalEntry().subscribe((data: any) => {
  //     const purchaseOrderNumberString = data.toString();
  //     this.purchaseOrderForm.patchValue({
  //       purchaseOrderNumber: purchaseOrderNumberString,
  //     });
  //   });
  // }

  get formControls() {
    return this.purchaseOrderForm.controls;
  }

  reset() {
    this.purchaseOrderForm.reset();
  }

  Cancel() {
    this.router.navigate(['/home/recievePurchaseOrderList']);
  }

  validateForm() {
    let isValid = true;
    if (this.purchaseOrderForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }
    return isValid;
  }

  setProduct(data: any) {
    this.purchaseOrderLineItemForm.controls.productCode.setValue(data.value.productCode);
    this.purchaseOrderLineItemForm.controls.productDescription.setValue(data.value.productName);
    this.purchaseOrderLineItemForm.controls.productId.setValue(data.value.productId);
    this.addProductData = data.value;
    this.setFieldFocus('productQty');
  }
  setFieldFocus(fieldKey: any) {
    const control = this.el.nativeElement.querySelector('[formcontrolname="' + fieldKey + '"]');
    if (control) {
      setTimeout(() => {
        control.focus();
      }, 100);
    }
  }

  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        } else {
        }
      },
      (error: any) => {
      }
    );
  }

  addProduct() {
    this.loader = true;
    this.submitted = true;
    const isValid = this.validateCustomer();

    this.checkIGST();

    if (!isValid) {
      window.scroll(0, 0);
      this.loader = false;
      return;
    }

    const lastItem = this.allProductData[this.allProductData.length - 1];

    const product: Product = <Product><unknown>{
      purchaseOrderNumber: this.purchaseOrderForm.controls.purchaseOrderNumber.value,
      ProductId: _.toNumber(this.purchaseOrderLineItemForm.controls.productId.value),
      POQuantity: _.toNumber(this.purchaseOrderLineItemForm.controls.productQty.value),
      ReceivedQuantity: 0,
      Uom: this.addProductData.unitsOfMeasure,
      LineItemNumber: (this.allProductData.length !== 0) ? lastItem.LineItemNumber + 1 : 1,
      IsTaxable: this.addProductData.isTaxable,
      Cost: Number(this.addProductData?.standardCost ?? 0).toFixed(2),
      Weight: this.addProductData.weight,
      GSTRate: this.addProductData.gst.gstRate,
      ExtendedCost: this.addProductData.standardCost * _.toNumber(this.purchaseOrderLineItemForm.controls.productQty.value),
      CGST: (!this.isIGST) ? this.calculateGST(this.addProductData.standardCost, _.toNumber(this.purchaseOrderLineItemForm.controls.productQty.value), this.addProductData.gst.gstRate, this.addProductData.isTaxable) / 2 : 0,
      SGST: (!this.isIGST) ? this.calculateGST(this.addProductData.standardCost, _.toNumber(this.purchaseOrderLineItemForm.controls.productQty.value), this.addProductData.gst.gstRate, this.addProductData.isTaxable) / 2 : 0,
      IGST: (this.isIGST) ? this.calculateGST(this.addProductData.standardCost, _.toNumber(this.purchaseOrderLineItemForm.controls.productQty.value), this.addProductData.gst.gstRate, this.addProductData.isTaxable) : 0,
      ProductCode: this.addProductData.productCode,
      ProductDescription: this.addProductData.productName,
      CreatedBy: _.toString(this.purchaseOrderLineItemForm.controls.CreatedBy.value),
      IsActive: true,
    }

    this.products.push(product);
    this.allProductData.push({ ...product });
    this.purchaseOrderLineItemForm.controls.productCode.setValue('');
    this.purchaseOrderLineItemForm.controls.productDescription.setValue('')
    this.purchaseOrderLineItemForm.controls.productQty.setValue('')
    this.loader = false;
    this.calculateOrderTotal();

  }

  onProductEdit(event: any) {
    let editData = event.data;
    const index = this.products.findIndex(product =>
      product.LineItemNumber === editData.LineItemNumber);
    if (index !== -1) {
      this.products[index] = {
        ...editData,
        Cost: _.toNumber(editData.Cost).toFixed(2),
        ExtendedCost: editData.Cost * editData.POQuantity,
        CGST: (!this.isIGST) ? this.calculateGST(editData.Cost, editData.POQuantity, editData.GSTRate, editData.IsTaxable) / 2 : 0,
        SGST: (!this.isIGST) ? this.calculateGST(editData.Cost, editData.POQuantity, editData.GSTRate, editData.IsTaxable) / 2 : 0,
        IGST: (this.isIGST) ? this.calculateGST(editData.Cost, editData.POQuantity, editData.GSTRate, editData.IsTaxable) : 0,
      };

      console.log(this.products[index]);
      this.calculateOrderTotal();
      // this.updatePOrderLineItem(editData)
    } else {
      console.error('Product not found', editData);
    }
  }

  // Function to check IGST based on warehouse and vendor states
  checkIGST() {

    if (this.warehouseState == this.vendorState) {
      this.isIGST = false;
    } else {
      this.isIGST = true;
    }
  }


  calculateGST(price: number, quantity: number, gstrate: number, taxable: boolean): number {
    if (taxable === true) {
      const gst = (price * quantity) * gstrate / 100;
      return gst;
    }
    else {
      return 0;
    }
  }

  calculateOrderTotal() {
    let orderTotal = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let taxable = 0;

    for (const product of this.products) {
      orderTotal += product.Cost * product.POQuantity;
      cgst += product.CGST;
      sgst += product.SGST;
      igst += product.IGST;
      taxable += product.ExtendedCost;
    }
    this.orderTotal = _.toNumber(orderTotal.toFixed(2));
    this.CGSTtotal = (!this.isIGST) ? _.toNumber(cgst.toFixed(2)) : 0;
    this.SGSTtotal = (!this.isIGST) ? _.toNumber(sgst.toFixed(2)) : 0;
    this.IGSTtotal = (this.isIGST) ? _.toNumber(igst.toFixed(2)) : 0;
    this.orderTotal += this.CGSTtotal + this.SGSTtotal + this.IGSTtotal;
    this.Taxable = taxable;

    this.TaxTotal = this.CGSTtotal + this.SGSTtotal + this.IGSTtotal;

    const temp = _.cloneDeep(this.products);
    this.products = temp;
    this.POLineItemData = this.products
    this.purchaseOrderForm.patchValue({
      poTotal: this.orderTotal,
      SGSTtotal: this.CGSTtotal,
      CGSTtotal: this.SGSTtotal,
      IGSTTotal: this.IGSTtotal,
      TaxTotal: this.TaxTotal

    });
    return true;
  }

  validateCustomer() {
    let isValid = true;
    if (!this.purchaseOrderForm.controls.purchaseOrderNumber?.valid ||
      !this.purchaseOrderForm.controls.warehouseCode.value ||
      !this.purchaseOrderForm.controls.vendorCode.value
    ) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }
    return isValid;
  }


  editPurchaseOrder() {
    this.route.queryParams.subscribe(params => {
      this.purchaseOrderId = params['purchaseOrderId'];
      this.isEditMode = !!this.purchaseOrderId;
      if (this.isEditMode) {
        this.porderservice.getPurchaseOrderById(this.purchaseOrderId).subscribe(
          (purchaseOrder: any) => {
            if (purchaseOrder) {

              const requestedDate = new Date(purchaseOrder.requestedDate);
              this.purchaseOrderForm.patchValue({
                ...purchaseOrder,
                'departments': `${purchaseOrder.department.departmentCode}`,
                'warehouses': purchaseOrder.warehouse.warehouseCode,
                'ShipToCustomerCode': purchaseOrder.shipToCustomerCode,
                'ShipToCustomerId': purchaseOrder.shipToCustomerId,
                'addressId': purchaseOrder.addressId,
                'add': `${purchaseOrder.vendor.address.addressLine1},${purchaseOrder.vendor.address.city
                  }, ${purchaseOrder.vendor.address.state},${purchaseOrder.vendor.address.country},${purchaseOrder.vendor.address.zip}`,
                'requestedDate': requestedDate,
                warehouseCode: purchaseOrder.warehouse.warehouseCode,
              });
              this.orderTotal = purchaseOrder.poTotal;
              this.TaxTotal = purchaseOrder.taxTotal;
              this.CGSTtotal = purchaseOrder.cgstTotal;
              this.SGSTtotal = purchaseOrder.sgstTotal;
              this.IGSTtotal = purchaseOrder.igstTotal;

              if (purchaseOrder.igstTotal !== 0) {
                this.isIGST = true
              }

              this.getShipto(purchaseOrder.shipToCustomerId);
              const data = purchaseOrder.purchaseOrderNumber;
              this.porderservice.getPurchaseOrderLineitemById(data).subscribe(
                (data: any) => {
                  this.products = this.loadProducts(data);
                  this.allProductData = this.products;
                  this.calculateOrderTotal();
                });
            }
          },
          (error: any) => {
            console.log(error);
          }
        );

      }
    })
  }

  getShipto(data: number) {
    this.loader = true;
    this.customerService.getCustomerById(data).subscribe({
      next: (data: any) => {
        const ShipTo = data;
        this.purchaseOrderForm.controls.ShipToCustomer.setValue(ShipTo.customerName);
        const address = `${ShipTo.address.city, ShipTo.address.state}, ${ShipTo.address.country}, ${ShipTo.address.zip}`;
        this.purchaseOrderForm.controls.ShipToCustomerAddress.setValue(address);
        this.loader = false;

      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    })
  }


  loadProducts(data: any): Product[] {
    return data.map((item: any) => {
      return this.loadProduct(item);
    });
  }

  loadProduct(data: any) {
    const product: Product = <Product>{
      purchaseOrderLineItemId: data.purchaseOrderLineItemId,
      PurchaseOrderNumber: data.purchaseOrderNumber,
      ProductId: data.productId,
      POQuantity: data.poQuantity,
      ReceivedQuantity: data.receivedQuantity,
      Uom: data.uom,
      LineItemNumber: data.lineItemNumber,
      IsTaxable: data.isTaxable,
      Cost: data.cost,
      UnitPrice: data.unitPrice,
      ExtendedCost: data.extendedCost,
      GSTRate: data.gstRate,
      HSNCode: data.hsnCode,
      CGST: data.cgst,
      SGST: data.sgst,
      IGST: data.igst,
      ProductCode: data.productCode,
      ProductDescription: data.productDescription,
      CreatedBy: data.createdBy,
      IsActive: true,
    }
    return product;
  }

  checkPurchaseNumber() {
    if (!this.purchaseOrderForm.controls.purchaseOrderNumber.value) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter' });
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEditMode) {
      this.porderservice.checkPurchaseOrderNumber(this.purchaseOrderForm.controls.purchaseOrderNumber.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.purchaseOrderForm.controls.purchaseOrderNumber.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.purchaseOrderForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  warning() {
    this.confirmationService.confirm({
      message: 'The entered quantity exceeds the available quantity. Please adjust the quantity.',
      header: 'Warning',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectVisible: false,
      acceptLabel: "OK",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
      },

    });
  }


  onReceivePOEnter(event: any){
    let editData = event.data;

    if (editData.POQuantity >= editData.ReceivedQuantity) {

    } else {
      editData.ReceivedQuantity = editData.POQuantity;  // If POQuantity is less than ReceivedQuantity, adjust ReceivedQuantity and call the warning method
      this.warning();
    }

    const index = this.products.findIndex(product =>
      product.LineItemNumber === editData.LineItemNumber);
    if (index !== -1) {
      this.products[index] = {
        ...editData,
        Cost: _.toNumber(editData.Cost).toFixed(2),
        ExtendedCost: editData.Cost * editData.ReceivedQuantity,
        CGST: (!this.isIGST) ? this.calculateGST(editData.Cost, editData.ReceivedQuantity, editData.GSTRate, editData.IsTaxable) / 2 : 0,
        SGST: (!this.isIGST) ? this.calculateGST(editData.Cost, editData.ReceivedQuantity, editData.GSTRate, editData.IsTaxable) / 2 : 0,
        IGST: (this.isIGST) ? this.calculateGST(editData.Cost, editData.ReceivedQuantity, editData.GSTRate, editData.IsTaxable) : 0,
      };

      this.calculateOrderTotal();
      // this.updatePOrderLineItem(editData)
    } else {
      console.error('Product not found', editData);
    }
  }


  receivePO() {
    let allZero = true;
  
    for (const product of this.products) {
      if (product.ReceivedQuantity !== 0) {
        allZero = false;
        break;
      }
    }
  
    if (allZero) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please Enter Received Quantity.' });
      return;
    }
  
    this.loader = true;
    // this.updateProducts(0);
  }


  // receive() {
  //   this.loader = true;

  //   const data = this.purchaseOrderForm.value;

  //   for (let product of this.products) {

  //     //Updating the product inventory with ledger creation

  //     const Inventory: UpdateInventory = <UpdateInventory>{
  //       productId: product.ProductId,
  //       warehouseId: data.warehouseId,
  //       productCode: product.ProductCode,
  //       status: "ReceivePO",
  //       transactionType: "Purchase Order",
  //       quantity: product.POQuantity,
  //       createdBy: sessionStorage.getItem('username'),
  //       transactionDate: new Date(),
  //       createdDate: new Date(),
  //     }

  //     // console.log(Inventory);
  //     this.inventoryService.updateInventory(Inventory).subscribe({
  //       next: (data: any) => {
  //         // console.log(data);
  //         this.loader = false;
  //       },
  //       error: error => {
  //         console.log(error);
  //         this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while PO was received.' });
  //         this.loader = false;
  //         return;
  //       }
  //     });

  //   }

  //   // Updating the PO  Status as Received

  //   setTimeout(() => {
  //     this.update(this.purchaseOrderForm.value);
  //   }, 500);

  // }

  // update(data: any) {
  //   data.PurchaseOrder_Status = 'Received';
  //   data.purchaseOrderId = this.purchaseOrderId;
  //   data.UpdatedBy = sessionStorage.getItem('username');
  //   if (data) {
  //     this.porderservice.updatePurchaseOrder(data).subscribe({
  //       next: data => {
  //         this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Received Successfully.' });
  //         setTimeout(() => {
  //         this.router.navigate(['/home/listPurchaseOrders']);
  //         this.loader = false;
  //         },500);
  //       },
  //       error: error => {
  //         console.error('Error updating PurchaseOrders:', error);
  //         this.loader = false;
  //       }
  //     });
  //   }
  // }

}
